<template>
  <div class="module-info">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item :label="$t('public.text13')">
        <el-radio-group
          v-model="ruleForm.guideFlag"
          :disabled="moduleState == 2"
        >
          <el-radio :label="0">{{ $t("public.text11") }}</el-radio>
          <el-radio :label="1">{{ $t("public.text12") }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        :label="$t('pages.equipment.text158')"
        v-if="ruleForm.guideFlag == 0"
      >
        <el-input
          v-model="ruleForm.richTextTittle"
          :disabled="moduleState == 2"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('pages.equipment.text159')"
        v-if="ruleForm.guideFlag == 0"
      >
        <DiluEditor
          v-model="ruleForm.richTextContent"
          :value="ruleForm.richTextContent"
          :disabled="moduleState == 2"
        />
      </el-form-item>
      <el-form-item :label="$t('public.text10')" v-if="ruleForm.guideFlag != 0" prop="guideLink">
        <el-input
          v-model="ruleForm.guideLink"
          :disabled="moduleState == 2"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="ruleForm.guideFlag != 0">
        <DiliUploadFile
          :limit="100"
          accept=".ble,.ccu,.bms,.dis,.ecu,.zip,.elk,.rgb,.ota,.bin,.pdf"
          :fileList="fileList"
          :showFileList="false"
          @remove="remove"
          @success="success"
          :uploaDisabled="false"
        />
      </el-form-item>
    </el-form>
  </div>
</template>


<script>
import DiliUploadFile from "../../../../components/pubilc/dili-uploadfile.vue";
import DiluEditor from "../../../../components/pubilc/dilu-ue.vue";
export default {
  data() {
    return {
      ruleForm: {
        richTextTittle: "",
        richTextContent: this.$t("pages.equipment.text159"),
        guideLink: "",
        guideFlag: 0,
      },
      fileList: [],
    };
  },
  watch: {
    ruleForm: {
      handler: function () {
        this.$emit("mergeParams", this.ruleForm);
      },
      deep: true,
    },
    activeName: {
      immediate: true,
      handler: function () {
        this.ruleForm = {
          richTextTittle: this.params.richTextTittle,
          richTextContent: this.params.richTextContent,
          guideLink: this.params.guideLink,
          guideFlag: this.params.guideFlag,
        };
      },
      deep: true,
    },
  },
  props: ["activeName", "params", "moduleState"],
  components: {
    DiluEditor,
    DiliUploadFile,
  },
  methods: {
    //删除文件
    remove(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      this.ruleForm.guideLink = "";
    },
    //文件上传成功
    success(e) {
      this.fileList = e.fileList;
      this.ruleForm.guideLink = e.url;
    },
  },
};
</script>

<style scoped>
.module-info {
  width: 95%;
}
</style>